import { render } from "./SettingsBrand.vue?vue&type=template&id=02665d4d&scoped=true"
import script from "./SettingsBrand.vue?vue&type=script&lang=js"
export * from "./SettingsBrand.vue?vue&type=script&lang=js"

import "./SettingsBrand.vue?vue&type=style&index=0&id=02665d4d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02665d4d"]])

export default __exports__